import { FeatureIcon } from '@components/icons/SvgIcons'
import { MainLayout } from '@components/layouts/MainLayout'
import { motion } from 'framer-motion'
import { useLocation } from 'react-router-dom'

export const QrScan: React.FC = () => {
  const location = useLocation()
  const { from } = (location.state as { from?: string } | null) ?? {}

  const transition = { duration: 0.32, ease: [0.4, 0, 0.2, 1] as const }
  const initial = from?.startsWith('/qr')
    ? { x: from === '/qr' ? '100%' : '-100%', opacity: 0 }
    : { x: 0, opacity: 1 }

  return (
    <MainLayout
      activeMain={null}
      secondaryLayout="qr"
      outerClassName="bg-[#05070B]"
      className="bg-[#05070B] text-white"
      contentClassName="flex flex-col px-6 pb-10 pt-6"
      bottomNavScrolledClassName="supports-[backdrop-filter]:backdrop-blur-[1px]"
      header={{
        enabled: true,
        title: 'スキャン',
        leftIcon: null,
        rightIcon: null,
        className: 'flex h-16 w-full items-center justify-between',
        containerClassName: 'pt-6 bg-transparent',
        offset: 104,
        scrolledClassName: 'supports-[backdrop-filter]:backdrop-blur-[1px]',
        titleClassName: 'text-white font-semibold',
      }}
    >
      <motion.div
        className="flex flex-1 items-center justify-center"
        initial={initial}
        animate={{ x: 0, opacity: 1 }}
        transition={transition}
      >
        <div className="w-full max-w-[360px]">
          <section className="rounded-2xl border border-white/15 bg-white/5 px-8 py-10 text-center backdrop-blur-sm">
            <div className="flex flex-col items-center gap-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10">
                <FeatureIcon className="h-6 w-6 text-white" decorative />
              </span>
              <div className="space-y-2">
                <h2 className="text-lg font-semibold">スキャン機能は準備中です</h2>
                <p className="text-sm leading-relaxed text-white/70">
                  もうすぐQRコードの読み取りに対応します。公開までしばらくお待ちください。
                </p>
              </div>
            </div>
          </section>
        </div>
      </motion.div>
    </MainLayout>
  )
}

export default QrScan
